import { sensorsInit } from '@spot-fe/utils';
import { FC, useCallback, useEffect } from 'react';

interface SensorsScriptProps {
  projectName?: string;
}

const SensorsScript: FC<SensorsScriptProps> = ({ projectName = '' }) => {

  useEffect(() => {
    sensorsInit({ projectName });
  }, []);

  return null;
};

export default SensorsScript;
